jQuery(function($) {
    // Function to show or hide the processing message popup
    function jwPopupCartMsg(show_or_hide) {
        if (show_or_hide == 'show') {
            $('#jw_popup_processing_overlay').show();
            $('#jw_popup_processing_main').show();
        } else {
            $('#jw_popup_processing_overlay').hide();
            $('#jw_popup_processing_main').hide();
        }
    }

    // Check if the freight dropdown exists on the page
    if ($('#jw_freight_prd_regions_dropdown_wrapper').length > 0) {

        // Initially hide the regions wrapper
    $("#jw_freight_prd_regions_dropdown_wrapper").hide();
         // When a freight option is selected
    $("#jw_freight_prd_dropdown").change(function() {
      var selectedFreight = $(this).val();
      
      // Reset all region dropdowns to "Please select"
      $("#jw_freight_prd_regions_dropdown_wrapper .jw_freight_prd_dropdown").val("");

      // Hide all region dropdowns initially
      $("#jw_freight_prd_regions_dropdown_wrapper .region-dropdown").hide();

      // Hide the regions wrapper if no freight is selected
      if (selectedFreight) {

        if(selectedFreight == 'jw_freight_pickup'){
          $('#jw-select-freight-sub-heading-label').html('Select Pickup Location');
        }else{
           $('#jw-select-freight-sub-heading-label').html('Select Regions');
        }
        
        // Show the corresponding region dropdown(s)
        $("#" + selectedFreight).show();

        // Show the regions wrapper
        $("#jw_freight_prd_regions_dropdown_wrapper").show();
      } else {
        // Hide the regions wrapper if no freight option is selected
        $("#jw_freight_prd_regions_dropdown_wrapper").hide();
      }
    });
      
        // Function to clean (remove) existing freight items from the cart
        function cleanFreightInCart() {
            // Loop through each option in the dropdown
            /*$('#jw_freight_prd_regions_dropdown_wrapper option').each(function() {
                var variantId = $(this).val(); // Get the variant ID from the option's value
              
                var selected_id = $('#jw_current_selected_freight').val();
                if(selected_id == variantId ){
                  console.log('do nonthing'+selected_id);
                  return;
                }
              
                  // If variant ID is valid (not empty)
                  if (variantId) {
                      // Construct the cart item selector based on the variant ID
                      var cartItemSelector = '.jw-cart-item-wrapper .jw-cart-item-' + variantId;
  
                      // Check if the cart item exists
                      if ($(cartItemSelector).length > 0) {
                          // Get the URL of the cart item to remove it
                          var url = $(cartItemSelector).attr('href');
                          var ajax_name = 'JWRemoveCartItem-'+variantId;
                          // Send an AJAX request to remove the item from the cart
                          $.ajaxq(ajax_name,{
                              type: 'GET', // Use GET to execute the URL
                              url: url, // The URL to call for removing the item
                              dataType: 'json',
                              success: function(response) {
                                  // Item removal was successful
                                  console.log(variantId + 'Item removed successfully', response);
                              },
                              error: function(error) {
                                  // Handle error in item removal
                                  console.log('Error removing item:', error);
                              }
                          });
                      }
                   
                }
            });*/
             var variantId = $('#jw_current_selected_freight').val();
          if (variantId) {
                      // Construct the cart item selector based on the variant ID
                      var cartItemSelector = '.jw-cart-item-wrapper .jw-cart-item-' + variantId;
  
                      // Check if the cart item exists
                      if ($(cartItemSelector).length > 0) {
                          // Get the URL of the cart item to remove it
                          var url = $(cartItemSelector).attr('href');
                          var ajax_name = 'JWRemoveCartItem-'+variantId;
                          // Send an AJAX request to remove the item from the cart
                          $.ajaxq(ajax_name,{
                              type: 'GET', // Use GET to execute the URL
                              url: url, // The URL to call for removing the item
                              dataType: 'json',
                              success: function(response) {
                                  // Item removal was successful
                                  console.log(variantId + 'Item removed successfully', response);
                              },
                              error: function(error) {
                                  // Handle error in item removal
                                  console.log('Error removing item:', error);
                              }
                          });
                      }
                   
                }
          
        }

        // Function to pre-select the freight item in the dropdown if it already exists in the cart
        function preSelectFreightInCart() {
            // Loop through each option in the dropdown
            $('#jw_freight_prd_regions_dropdown_wrapper option').each(function() {
                var variantId = $(this).val(); // Get the variant ID from the option's value

                // If variant ID is valid (not empty)
                if (variantId) {
                    // Construct the cart item selector based on the variant ID
                    var cartItemSelector = '.jw-cart-item-wrapper .jw-cart-item-' + variantId;

                    // Check if the cart item exists
                    if ($(cartItemSelector).length > 0) {
                        // Get the region from the option's data attribute (data-region is used here)
                        var region = $(this).data("region");
                        //console.log(region);
                         if(region == 'pickup'){
                            $('#jw-select-freight-sub-heading-label').html('Select Pickup Location');
                          }else{
                             $('#jw-select-freight-sub-heading-label').html('Select Regions');
                          }  
                      
                        var region_seleted_id = 'jw_freight_'+region;
                        // Mark the option as selected and store the variant ID
                        $(this).prop('selected', true);
                        $('#jw_current_selected_freight').val(variantId);
            
                        

                        $('#jw_freight_prd_dropdown').val(region_seleted_id);
                       // Show the corresponding region dropdown
                        $("#" + region_seleted_id).show(); 
                      $('#jw_freight_prd_regions_dropdown_wrapper').show();
                        return false; // Exit the loop once the match is found
                    }
                }
            });

          //cleanFreightInCart();
        }

        // Pre-select the freight item in the dropdown based on the cart
        preSelectFreightInCart();

        // Function to get the selected region value
        function getSelectedRegionValue() {
          // Find the visible region dropdown
          var visibleRegionDropdown = $(".region-dropdown:visible select");
    
          // Get the value of the selected option
          var selectedRegionValue = visibleRegionDropdown.val();
    
          return selectedRegionValue;
        }

      
        // Listen for the dropdown change event (when a new variant is selected)
       $("#jw_freight_prd_regions_dropdown_wrapper").on('change', '.jw_freight_prd_dropdown', function() {
            jwPopupCartMsg('show'); // Show processing popup

            var variantId = getSelectedRegionValue(); // Get the selected variant ID
            // $('#jw_current_selected_freight').val(variantId);
          // console.log("Selected Region Value: " + variantId); // You can handle this value as needed

           
          
            // If a valid variant ID is selected or already stored
            if (variantId) {
              
                // Prepare the data to add the selected freight item to the cart
               /* var my_items = [{
                    'id': variantId,  // The variant ID of the selected freight item
                    'quantity': 1      // Quantity set to 1 for the selected freight item
                }];

                const data = { 'items': my_items }; // Wrap the items data in an object

                // Create an XMLHttpRequest to add the item to the cart
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/cart/add.js', true); // Make a POST request to add the item to the cart
                xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8'); // Set the content type for the request
                xhr.send(JSON.stringify(data));  // Send the data as JSON

                // Handle the response when the request completes
                xhr.onload = function() {
                    if (xhr.status == 200) { // If the status is OK (200)
                        // Reload the page after a short delay to reflect the cart update
                        setTimeout(function() {
                            //location.reload();
                           console.log("rrrr");
                        }, 3000);
                    } else {
                        // Handle error if the status is not 200 (OK)
                        console.log('Error adding item to cart:', xhr.status, xhr.responseText);
                    }
                };

                xhr.onerror = function() {
                    // Handle network errors
                    console.log('Request failed.');
                };*/
              var my_items = [{
                    'id': variantId,  // The variant ID of the selected freight item
                    'quantity': 1      // Quantity set to 1 for the selected freight item
                }];

                const data = { 'items': my_items }; // Wrap the items data in an object
             $.ajaxq('add_to_cart',{
                  type: 'POST',
                  url: '/cart/add.js',
                  data: data,
                  dataType: 'json',
                  success: function(response) {
                       // First, clean the cart of any existing freight items
               cleanFreightInCart();
                    setTimeout(function() {
                            location.reload();
                        }, 2000);
                  },
                  error: function(error) {
                    console.error('Error adding to cart:', error);
                  }
                });
            } else {
                // Reload the page after a short delay to reflect the cart update
                setTimeout(function() {
                    location.reload();
                }, 2000);
            }
        });
    }

 

   
});
